import React, { Component } from 'react'
import _ from 'lodash'
import MovingContainer from './canvas/MovingContainer'
import MCAnimations from './canvas/MCAnimations'
import * as c from '../constants/Constants'
import * as Utils from './canvas/util/Utils'

const VENDOR_PREFIX = (function () {

  var regex = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/,

    styleDeclaration = document.getElementsByTagName("script")[ 0 ].style;

  for (var prop in styleDeclaration) {
    if (regex.test(prop)) {
      return prop.match(regex)[ 0 ].toLowerCase();
    }
  }

  // Nothing found so far? Webkit does not enumerate over the CSS properties of the style object.
  // However (prop in style) returns the correct value, so we'll have to test for
  // the precence of a specific property
  if ("WebkitOpacity" in styleDeclaration) { return "webkit"; }
  if ("KhtmlOpacity" in styleDeclaration) { return "khtml"; }

  return "";
}());

export default class Canvas extends Component {

  render() {
    return (
      <div id="animation_container" >
        <canvas id="canvas" width="1060" height="602" />
      </div>
    )
  }

  componentDidMount() {
    var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
    var createjs = window.createjs;
    var lib = window.lib;
    init.bind(this)();
    const actions = this.props.actions;
    var images;
    function init () {
      this.canvas = canvas = document.getElementById("canvas");
      anim_container = document.getElementById("animation_container");
      dom_overlay_container = document.getElementById("dom_overlay_container");
      images = window.images || {};
      var loader = new window.createjs.LoadQueue(false);
      loader.addEventListener("fileload", handleFileLoad);
      loader.addEventListener("complete", handleComplete.bind(this));
      loader.loadManifest(window.lib.properties.manifest);
    }
    function handleFileLoad (evt) {
      if (evt.item.type == "image") { images[ evt.item.id ] = evt.result; }
    }
    function handleComplete (evt) {
      //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var queue = evt.target;
      var ssMetadata = window.lib.ssMetadata;
      for (var i = 0; i < ssMetadata.length; i++) {
        window.ss[ ssMetadata[ i ].name ] = new window.createjs.SpriteSheet({
          "images": [ queue.getResult(ssMetadata[ i ].name) ],
          "frames": ssMetadata[ i ].frames
        })
      }
      this.exportRoot = exportRoot = new lib.ja();
      
      this.stage = stage = new createjs.Stage(canvas);
      if (createjs.Touch.isSupported()) {
        createjs.Touch.enable(stage);
      }
      new MovingContainer(stage, exportRoot, actions.setMouseDown, actions.setScrollPosition);
      this.mcAnimations = new MCAnimations(stage, exportRoot, canvas, actions);
      
      exportRoot.addEventListener("added", ()=>{
        const { actions, canvas } = this.props
        
        actions.startCanvas();
        
        createjs.Tween
          .get(exportRoot.cover)
          .wait(1000)
          .to({alpha:0.01}, 700, createjs.Ease.sineInOut)
          .call(()=>{
          setTimeout(()=>{
            exportRoot.cover.visible = false;
            exportRoot.removeChild(exportRoot.cover);
          }, 1000);
            
            if(this.checkVisitingFirst()) {
              const firstPop = exportRoot.container.firstPop;
              firstPop.cursor = "pointer";
              firstPop.scaleX = 
              firstPop.scaleY = 0;
              firstPop.visible = true;

              firstPop.addEventListener("rollover", (e) => {
                actions.setNumMouseOver(1);
              });
              firstPop.addEventListener("rollout", (e) => {
                actions.setNumMouseOver(-1);
              });
              firstPop.addEventListener("click", (e)=>{
                firstPop.visible = false;
                firstPop.parent.removeChild(firstPop);
                e.remove();
                this.mcAnimations.startHouse();
              });
              createjs.Tween.get(firstPop)
                .wait(1500)
                .to({scaleX:1, scaleY:1},  2000, createjs.Ease.elasticOut)
            } else {
              this.mcAnimations.startHouse();
            }
            // exportRoot.board.dispatchEvent(new createjs.Event("pressup"))
          })
      });
      stage.addChild(exportRoot);
      //Registers the "tick" event listener.
      fnStartAnimation = function () {
        // createjs.Ticker.timingMode = createjs.Ticker.RAF;
        createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
        // createjs.Ticker.setFPS(lib.properties.fps);
        // createjs.Ticker.setFPS(5);
        // createjs.Ticker.framerate = 5;
        createjs.Ticker.framerate = 24;
        createjs.Ticker.addEventListener("tick", stage);
      }
      window.addEventListener('resize', resizeCanvas.bind(this));
      resizeCanvas.bind(this)();
      canvas.height = c.MAX_H;
      document.body.style.height = c.MAX_H + "px"
      function resizeCanvas() {
        let iw = window.document.documentElement.clientWidth;
        let ih = window.innerHeight;
        let cw = canvas.width;
        let h
        
        if(ih <= c.MIN_H) {
          h = c.MIN_H
        }
        else if(ih > c.MIN_H && ih < c.MAX_H) {
          h = ih
        } 
        else if(ih >= c.MAX_H) {
          h = c.MAX_H
        }
        let sc = h/c.MAX_H
        
        if(iw !== cw || canvas.height !== h) {
          canvas.width = iw;
          // canvas.height = h;
          // stage.scaleX = stage.scaleY = sc
          // document.body.style.height = h + "px"
          // const scw = (c.CAN_W - (c.CAN_W * sc))
          // stage.x = scw;
          
          let add = 0
          if(iw>=961 && iw <= 961+240*2) {
            add = (iw - 961) /2
          } else if(iw > 961+240*2) {
            add=240
          }
          exportRoot.x = -(c.CAN_W/2) + iw/2;
          exportRoot.board.x = 138 - exportRoot.x + add
          Utils.changeContainerX(exportRoot.container.x, stage, exportRoot.container, exportRoot.container_up)
        }
      }

      fnStartAnimation();


      // DEBUG
      // stage.addEventListener("click", ()=>{
      //   const container = exportRoot.container;
      //   container.parent.removeChild(container);
        // const index = Math.floor(Math.random() * container.numChildren);
        // const child = container.getChildAt(index);
        // if(child) {
        //   child.parent.removeChild(child);
        //   console.log(index, child, "removed")
        // } else {
        //   console.log("none")
        // }
        // console.log("numChildren:", container.numChildren);
      // });
      
      // setTimeout(()=>{
      //   console.log(exportRoot.board2);
      //   createjs.Tween.get(exportRoot.board2).to({rotation:100}, 1000)
      // }, 5000);

      const b = exportRoot.board;

      let mouseX =0;
      let defRotate = 0;
      setCursor("grab", b);
      b.addEventListener("rollover", (e) => {
        actions.setNumMouseOver(1);
      });
      b.addEventListener("rollout", (e) => {
        actions.setNumMouseOver(-1);
      });
      b.addEventListener("mousedown", (e)=>{
        createjs.Tween.removeTweens(b);
        mouseX = stage.mouseX;
        defRotate = b.rotation;
        setCursor("grabbing", b);
      });
      b.addEventListener("pressup", (e)=>{
        // console.log(e.type, b.rotation);
        // b.rotation = 0;
        if(Math.abs(b.rotation) < 1) {
          createjs.Tween.get(b)
            .to({rotation:((Math.random()<0.5)?1:-1) * (5 * Math.random() + 5)}, 200, createjs.Ease.sineOut)
            .to({rotation:0},  2000, createjs.Ease.elasticOut)

        } else {
          createjs.Tween.get(b).to({rotation:0}, Math.abs(b.rotation)*50 + 1000, createjs.Ease.elasticOut)
        }
        setCursor("grab", b);
      });
      b.addEventListener("pressmove", (e)=>{
        let nowx = stage.mouseX
        b.rotation = -(nowx-mouseX)/4;
        // console.log(e.type, nowx, nowx-mouseX);
      })

      function setCursor (prop, ct) {
        switch (prop) {
          case "grab":
          case "grabbing":
            if(
              window.document.documentMode && 
              typeof window.document.documentMode === "number" && 
              window.document.documentMode <= 11
            ) {
              ct.cursor = "move";
            } else {
              if (VENDOR_PREFIX) {
                ct.cursor = `-${VENDOR_PREFIX}-${prop}`
              } else {
                ct.cursor = prop
              }
            }
            
            break;
          case "auto":
            ct.cursor = null
            break;
        }
      }
    }

  }

  
  
  componentDidUpdate() {
    this.mcAnimations.changeCanvas(this.props.canvas)
  }


  checkVisitingFirst() {
    if(('localStorage' in window) && (window.localStorage !== null)) {
      const isVisited = window.localStorage.getItem('isVisited') === "true";
      if(!isVisited) {
        window.localStorage.setItem('isVisited', 'true');
      }
      return !isVisited
    } else {
      return true
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Canvas.js
 **/